import _ from 'lodash';
import supportedEventConditions from './supportedEventConditions';
export default class EventCondition {
    static load(filterOnProperty, filterPath = '') {
        return {
            description: 'Optional event filter. List filtered by Event.',
            key: 'eventCondition',
            type: 'datagrid',
            label: '',
            hidden: false,
            components: [
                {
                    label: 'Event Data Property',
                    key: 'eventData',
                    type: 'select',
                    dataSrc: 'custom',
                    refreshOn: filterOnProperty,
                    clearOnRefresh: true,
                    data: {
                        custom: ({ data }) => {
                            const filterPropertyRawValue = _.get(data, filterOnProperty);
                            const filterPropertyValue = _.get(filterPropertyRawValue, filterPath, filterPropertyRawValue);
                            const values = _.map(supportedEventConditions[filterPropertyValue]?.eventData, (event) => event.label ?
                                {
                                    label: _.startCase(event.label),
                                    value: event.value
                                } :
                                { label: _.startCase(event), value: event });
                            return values;
                        },
                    },
                    // logic: [{
                    //   trigger: {
                    //     type: 'javascript',
                    //     javascript: `
                    //       result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
                    //     `
                    //   },
                    //   actions: [{
                    //     type: 'property',
                    //     property: {
                    //       type: 'boolean',
                    //       value: 'validate.required',
                    //     },
                    //     state: true
                    //   }]
                    // }]
                },
                {
                    label: 'Comparison Operator',
                    key: 'type',
                    type: 'select',
                    multi: false,
                    data: {
                        values: [{
                                label: 'Equals (String)',
                                value: 'iequals'
                            }, {
                                label: 'Equals (Number)',
                                value: 'equals' // note: equals also compare strings. Using different operator allows pattern to b dynamic
                            }, {
                                label: 'Greater Than (Number)',
                                value: 'greaterthan'
                            }, {
                                label: 'Less Than (Number)',
                                value: 'lessthan'
                            }, {
                                label: 'Outside of Range',
                                value: 'search'
                            }
                        ]
                    },
                    logic: [{
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
              `
                            },
                            actions: [{
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'validate.required',
                                    },
                                    state: true
                                }]
                        }]
                }, {
                    label: 'String Value',
                    key: 'patternString',
                    type: 'textfield',
                    logic: [
                        {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type === 'iequals');
              `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: false
                                    // }, {
                                    //   type: 'property',
                                    //   property: {
                                    //     type: 'string',
                                    //     value: 'key',
                                    //   },
                                    //   text: 'pattern'
                                }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type !== 'iequals');
              `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: true
                                },
                                // {
                                //   type: 'property',
                                //   property: {
                                //     type: 'string',
                                //     value: 'key',
                                //   },
                                //   state: 'patternString'
                                // }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
              `
                            },
                            actions: [{
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'validate.required',
                                    },
                                    state: true
                                }]
                        }
                    ]
                }, {
                    label: 'Number Value',
                    key: 'patternNumber',
                    type: 'number',
                    logic: [
                        {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = _.includes(['equals', 'lessthan', 'greaterthan'], row.type);
              `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: false
                                    // }, {
                                    //   type: 'property',
                                    //   property: {
                                    //     type: 'string',
                                    //     value: 'key',
                                    //   },
                                    //   text: 'pattern'
                                }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = !_.includes(['equals', 'lessthan', 'greaterthan'], row.type);
              `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: true
                                    // }, {
                                    //   type: 'property',
                                    //   property: {
                                    //     type: 'string',
                                    //     value: 'key',
                                    //   },
                                    //   text: 'patternNumber'
                                }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
              `
                            },
                            actions: [{
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'validate.required',
                                    },
                                    state: true
                                }]
                        }
                    ]
                }, {
                    label: 'Min Range',
                    key: 'minPatternObj',
                    type: 'number',
                    hidden: true,
                    logic: [
                        {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type === 'search');
                `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: false
                                }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type !== 'search');
                `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: true
                                }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
              `
                            },
                            actions: [{
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'validate.required',
                                    },
                                    state: true
                                }]
                        }
                    ]
                },
                {
                    label: 'Max Range',
                    key: 'maxPatternObj',
                    type: 'number',
                    hidden: true,
                    logic: [
                        {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type === 'search');
                `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: false
                                }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type !== 'search');
                `
                            },
                            actions: [
                                {
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'hidden',
                                    },
                                    state: true
                                }
                            ]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
              `
                            },
                            actions: [{
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'validate.required',
                                    },
                                    state: true
                                }]
                        }
                    ]
                }, {
                    label: 'Condition',
                    key: 'condition',
                    type: 'textfield',
                    hidden: true,
                    clearOnHide: false,
                    logic: [
                        {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type === 'search');
                `
                            },
                            actions: [{
                                    name: 'Set condition',
                                    type: 'value',
                                    value: `
                  value = 'all2any'
                `
                                }]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = (row.type !== 'search');
                `
                            },
                            actions: [{
                                    name: 'Set condition',
                                    type: 'value',
                                    value: `
                  value = ''
                `
                                }]
                        }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
              `
                            },
                            actions: [{
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'validate.required',
                                    },
                                    state: true
                                }]
                        }
                    ]
                }, {
                    label: 'Range',
                    key: 'patternObj',
                    type: 'textfield',
                    hidden: true,
                    clearOnHide: false,
                    logic: [
                        {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.type === 'search';
              `
                            },
                            actions: [{
                                    //   type: 'property',
                                    //   property: {
                                    //     type: 'string',
                                    //     value: 'key',
                                    //   },
                                    //   text: 'pattern'
                                    // }, {
                                    name: 'Set datagrid',
                                    type: 'value',
                                    value: `
                const minPatternKey = 'item.' + row.eventData.value;
                const minPatternValue =  {
                  type: 'lessthan',
                  pattern: row.minPatternObj,
                  eventData: row.eventData,
                  minPatternObj: row.minPatternObj,
                  maxPatternObj: row.maxPatternObj
                }
                const maxPatternKey = minPatternKey + '#2';
                const maxPatternValue = {
                  type: 'greaterthan',
                  pattern: row.maxPatternObj,
                  eventData: row.eventData,
                  minPatternObj: row.minPatternObj,
                  maxPatternObj: row.maxPatternObj
                }
                const output = {};
                output[minPatternKey] = minPatternValue;
                output[maxPatternKey] = maxPatternValue;
                value = output;
                `
                                }]
                        }, {
                            //   trigger: {
                            //     type: 'javascript',
                            //     javascript: `
                            //     result = row.type !== 'search';
                            //   `
                            //   },
                            //   actions: [{
                            //     type: 'property',
                            //     property: {
                            //       type: 'string',
                            //       value: 'key',
                            //     },
                            //     text: 'patternObj'
                            //   }]
                            // }, {
                            trigger: {
                                type: 'javascript',
                                javascript: `
                result = row.eventData?.value || row.type || (row.pattern && !row?.hidden);
              `
                            },
                            actions: [{
                                    type: 'property',
                                    property: {
                                        type: 'boolean',
                                        value: 'validate.required',
                                    },
                                    state: true
                                }]
                        }
                    ]
                }, {
                    label: 'DataGrid',
                    key: 'dataGrid',
                    type: 'textfield',
                    clearOnHide: false,
                    hidden: true,
                    logic: [{
                            trigger: {
                                type: 'javascript',
                                javascript: `
            result = row.eventData?.value?.length > 0;
            `
                            },
                            actions: [{
                                    name: 'Set datagrid',
                                    type: 'value',
                                    value: `
              const rowTypeSearch = row.type === 'search';
              const criteriaKey = rowTypeSearch ? '' : '.' + row.eventData.value;
              value = JSON.stringify({
                model: instance.parent.component.key,
                path: ["criteria", "trigger.body.data.data" + criteriaKey],
                search: rowTypeSearch
              });
            `
                                }]
                        }]
                }
            ]
        };
    }
}
